module.exports = __webpack_public_path__ + "img/man.ea3f4897.png";